export const NS_XSL = 'http://www.w3.org/1999/XSL/Transform';
export const NS_XPATH_FUNCTIONS = 'http://www.w3.org/2005/xpath-functions';
